module.exports = __webpack_public_path__ + "media/svg-new/email-login-3b4ba9b2.svg";